/**
 * Compras copy (`en`): tall «devolucions» de les millores de Compres (OBR-190 / OBR-181 / OBR-117). Tall propi: no es toca `en.ts`.
 * Les tres llengües han de tenir les mateixes claus (i18n.test.ts); cap text literal a les vistes.
 */

export const devolucionsEn = {
  // Returned lot, immediate return and return observations (OBR-117, QA sheet of 19/10).
  'backoffice.returnedLots': {
    lotStatusReturned: 'Returned',
    immediateChip: 'Immediate return',
    immediateCardNote:
      'The carrier took it away on the spot: the reception entry and the exit of this return cancel each other out, and this quantity does not stay in stock.',
    immediateMovementNote:
      'An immediate return leaves, on the same lot, the reception entry and the return exit: what goes back does not stay in stock. Movements are never edited, which is why you see both.',
    movementReturnNumber: 'Return delivery note {{number}}',
    createErrorObservationsTooLong: 'The observations are too long (maximum {{max}} characters).',
    rejectObservationsLabel: 'Observations (optional)',
    rejectObservationsHint: 'They are added to every return that gets created, besides the reason.',
  },
} as const;
